var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.localEvent)?_c('v-container',{staticClass:"grid-list-md"},[_c('h1',{staticClass:"display-1",staticStyle:{"display":"inline-block"}},[_vm._v(_vm._s(_vm.localEvent.title))]),_c('event-details',{attrs:{"event":_vm.localEvent},on:{"updated":_vm.init}}),_c('event-guests')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }